<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">
      <div v-if="form.type==80||form.type==81||form.type==82">
        <el-form-item label="申请单位:">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="车辆:" v-if="form.car">
          {{ form.car.type+' - '+form.car.xh+' - '+form.car.plateNo }}
        </el-form-item>
        <el-form-item label="使用时间:" class="full">
          {{ form.startTime+' 至 '+form.endTime }}
        </el-form-item>
        <el-form-item label="事由及目的地:" class="full">
          {{ form.reason }}
        </el-form-item>
        <el-form-item label="驾驶人:" v-if="form.driver && form.driver.id">
          <user-info :userData='form.driver'></user-info>
        </el-form-item>
      </div>
      <div v-if="form.type==83 || form.type==87 || form.type==91">
        <el-form-item label="送修单位:">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="送修人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="维修车辆:" class="full">
          <span v-if="form.car">
            {{ form.car.xh+' - '+form.car.plateNo+' - '+form.car.type }}
          </span>
          <span v-else>未填写车辆信息</span>
        </el-form-item>
        <el-form-item label="维修单位:">
          {{form.wxdw}}
        </el-form-item>
        <el-form-item label="预计费用(元):">
          {{form.price}}
        </el-form-item>
        <el-form-item label="预计维修时间:" class="full">
          {{ form.startTime+' 至 '+form.endTime }}
        </el-form-item>
        <el-form-item label="报修内容:" class="full">
          {{ form.reason }}
        </el-form-item>
      </div>

      <div v-if="form.type==88">
        <div class="clear">
          <div class="tip" style="margin:0 0 0 20px">* 维修审批信息</div>
          <el-form-item label="送修单位:">
            {{form.wxApply.department.name}}
          </el-form-item>
          <el-form-item label="送修人:">
            <user-info :userData='form.wxApply.creator'></user-info>
          </el-form-item>
          <el-form-item label="维修车辆:" class="full">
            {{ form.wxApply.car.xh+' - '+form.wxApply.car.plateNo+' - '+form.wxApply.car.type }}
          </el-form-item>
          <el-form-item label="维修单位:">
            {{form.wxApply.wxdw}}
          </el-form-item>
          <el-form-item label="预计费用(元):">
            {{form.wxApply.price}}
          </el-form-item>
          <el-form-item label="预计维修时间:" class="full">
            {{ form.wxApply.startTime+' 至 '+form.wxApply.endTime }}
          </el-form-item>
          <el-form-item label="报修内容:" class="full">
            {{ form.wxApply.reason }}
          </el-form-item>
        </div>
        <div class="clear">
          <div class="tip" style="margin:15px 0 0 20px">* 验收申请内容</div>
          <el-form-item label="提交验收时间:">{{getTime(form.flow.createTime)}}</el-form-item>
          <el-form-item label="维修前:" class="full">
            {{ form.wxq }}
          </el-form-item>
          <el-form-item label="维修后:" class="full">
            {{ form.wxh }}
          </el-form-item>
        </div>

      </div>

      <div v-if="form.type==84 || form.type==85">
        <el-form-item label="申请单位:">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="申请日期:">
          {{ form.applyTime }}
        </el-form-item>
        <el-form-item label="出发时间:">
          {{ form.setOutTime }}
        </el-form-item>
        <div v-if="form.type==84">
          <el-form-item label="派遣车辆信息:">
            {{ form.car.xh+' - '+form.car.plateNo }}
          </el-form-item>
          <el-form-item label="用车地点:">
            {{form.address}}
          </el-form-item>
        </div>
        <el-form-item label="用车事由:" class="full">
          {{ form.reason }}
        </el-form-item>
      </div>

      <div v-if="form.type==86">
        <el-form-item label="申请单位:">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="车辆类型:">
          {{ form.carType }}
        </el-form-item>
        <el-form-item label="用车日期:">
          {{ form.useTime }}
        </el-form-item>
        <el-form-item label="起止时间:" class="full">
          {{ form.startTime+' 至 '+form.endTime }}
        </el-form-item>
        <el-form-item label="项目名称:">
          {{ form.xmName }}
        </el-form-item>
        <el-form-item label="用车人:">
          <user-info :userData='form.driver'></user-info>
        </el-form-item>
      </div>

      <div v-if="form.type==89">
        <el-form-item label="相关车辆:">
          {{ form.car.xh+" - "+form.car.plateNo+" - "+form.car.type }}
        </el-form-item>

        <div class="clear" style="clear:both">
          <div class="tip" style="margin:0 0 0 20px">* 里程抄见数(0.10元/公里)</div>
          <el-form-item label="上期数:">
            {{ form.sqs }}
          </el-form-item>
          <el-form-item label="本期数:">
            {{ form.bqs }}
          </el-form-item>
          <el-form-item label="补贴金额:">
            {{ form.btje }}
          </el-form-item>
        </div>
        <div class="clear">
          <div class="tip" style="margin:0 0 0 20px">* 奖励信息</div>
          <el-form-item label="奖励事项:">
            {{ form.jlsx }}
          </el-form-item>
          <el-form-item label="奖励金额:">
            {{ form.jlje }}
          </el-form-item>
        </div>
        <div class="clear">
          <div class="tip" style="margin:0 0 0 20px">* 处罚信息</div>
          <el-form-item label="处罚事项:">
            {{ form.cfsx }}
          </el-form-item>
          <el-form-item label="处罚金额:">
            {{ form.cfje }}
          </el-form-item>
        </div>
        <div class="clear">
          <div class="tip" style="margin:0 0 0 20px">* 核发金额信息</div>
          <el-form-item label="核发金额总计:">
            {{ form.total }}元
          </el-form-item>
          <el-form-item label="大写金额:">
            {{ form.totalDx }}
          </el-form-item>
        </div>
      </div>

      <div v-if="form.type==90">
        <el-form-item label="申请单位:">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="车辆数据:">
          {{ form.xh+" - "+form.pl }}
        </el-form-item>
        <el-form-item label="购置数量:">
          {{ form.amount }}
        </el-form-item>
        <el-form-item label="购置或更新:">
          {{ form.addType==0?'购置':'更新' }}
        </el-form-item>
        <el-form-item label="车辆价格:">
          {{ form.price }}
        </el-form-item>
        <el-form-item label="申请日期:">
          {{ form.applyTime }}
        </el-form-item>
        <el-form-item label="购车理由" class="full">
          {{ form.reason }}
        </el-form-item>
      </div>



    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {},
    props: ['form', 'flowUser'],
    data() {
      return {}
    },
    methods: {
      getTime(t) {
        return util.getFormatDate(t, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/car/components/applyDetail.vue